<template>
  <div class="triger-container">
    <div class="triger">
      <p class="title">{{title}}</p>
      <div class="slects">
        <el-form
          :model="localForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm">
          <div class="slect-top">
            <el-select
              @input="triggerModeChange"
              v-model="form.params.triggerMode"
              placeholder="触发类型">
              <el-option
                v-for="(item,index) in options1"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select
              v-if="form.params.triggerMode==='1'"
              @change="productTypeChange"
              v-model="form.params.productKey"
              placeholder="请选择产品类型">
              <el-option
                v-for="(item,index) in productList"
                :key="index"
                :label="item.productName"
                :value="item.productKey">
              </el-option>
            </el-select>
            <el-form-item
              v-if="form.params.triggerMode==='2'"
              prop="mount">
              <el-input
                v-model="localForm.mount"
                placeholder="请输入定时器参数">
              </el-input>
            </el-form-item>
            <el-select
              :disabled="!form.params.productKey"
              @change="deviceChange"
              v-if="form.params.triggerMode==='1'"
              v-model="form.params.deviceName"
              placeholder="请选择设备">
              <el-option
                v-for="(item, index) in options3"
                :key="index"
                :label="item.deviceName"
                :value="item.deviceName">
              </el-option>
            </el-select>
          </div>
          <div class="select-bottom" v-if="form.params.triggerMode==='1'">
            <el-select
              :disabled="!form.params.deviceName"
              @change="triggerWayChange"
              v-model="form.params.triggerType"
              placeholder="请选择触发方式">
              <el-option
                v-for="(item,index) in options4"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select
              :disabled="!form.params.triggerType"
              @change="triggerPropChange"
              v-model="form.params.propertyName"
              placeholder="请选择属性">
              <el-option
                v-for="(item, index) in options5"
                :key="index"
                :label="item.name"
                :value="item.identifier">
              </el-option>
            </el-select>
            <el-select
              :disabled="!form.params.propertyName"
              @change="triggerCompareChange"
              v-model="form.params.compareType"
              placeholder="请选择比较模式">
              <el-option
                v-for="item in options6"
                :key="item.value"
                :value="item.value">
              </el-option>
            </el-select>

            <el-form-item
              v-if="compareType===1"
              prop="compareValue"
              label="">
              <el-input
                v-if="form.params.compareType!=='in'&&form.params.compareType!=='between'"
                @change="inputChange"
                @input="$forceUpdate()"
                v-model.number="localForm.compareValue"
                :disabled="!form.params.compareType"
                placeholder="请输入数值">
              </el-input>
              <el-input
                v-else
                @change="inputChange"
                @input="$forceUpdate()"
                v-model.number="localForm.compareValue"
                :disabled="!form.params.compareType"
                placeholder="请输入数值">
              </el-input>
            </el-form-item>
            <el-select
              @change="stateChange"
              :disabled="!form.params.compareType"
              v-if="compareType===0"
              v-model="localForm.compareValue"
              placeholder="请选择比较值">
              <el-option
                v-for="(item,index) in options7"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!--          <div class="select-last" v-if="false">-->
          <!--            <el-select-->
          <!--              :disabled="!form.params.deviceName"-->
          <!--              @change="triggerWayChange"-->
          <!--              v-model="form.params.triggerType"-->
          <!--              placeholder="请选择触发方式">-->
          <!--              <el-option-->
          <!--                v-for="(item,index) in options4"-->
          <!--                :key="index"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value">-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </div>-->
        </el-form>
      </div>
    </div>
    <el-button
      type="text"
      @click="deleteItem">
      删除
    </el-button>
  </div>
</template>

<script>
import { deviceList, getProductProp } from '@/api/ruleEngine.js'

let compareRange = {}
// eslint-disable-next-line no-unused-vars
let compareValue = '<'
const validatePass = function (rule, value, callback) {
  if (compareValue === 'in') {
    let arr = []
    try {
      arr = JSON.parse(value)
    } catch (e) {
      callback(new Error('例如输入[1,2,3,4]'))
      return
    }
    if (!Array.isArray(arr)) {
      callback(new Error('例如输入[1,2,3,4]'))
    } else {
      for (const item in arr) {
        if (item > compareRange.max || item < compareRange.min) {
          callback(new Error('超过限定数字范围'))
          break
        }
      }
    }
  } else if (compareValue === 'between') {
    let arr = []
    try {
      arr = JSON.parse(value)
    } catch (e) {
      callback(new Error('例如输入[1,2,3,4]'))
      return
    }
    if (!Array.isArray(arr)) {
      callback(new Error('例如输入[1,4]'))
    } else {
      for (const item in arr) {
        if (item > compareRange.max || item < compareRange.min) {
          callback(new Error('超过限定数字范围'))
          break
        }
      }
    }
  } else {
    var value1 = parseFloat(value)
    if (value1 > compareRange.max || value1 < compareRange.min) {
      callback(new Error('超过限定数字范围'))
    }
    callback()
  }
}
export default {
  name: 'trigerItem',
  data () {
    return {
      triggerType: 0,
      value1: '',
      productInfo: {},
      compareRange: {},
      propData: {},
      compareType: 0,
      rules: {
        compareValue: [
          {
            required: true,
            message: '请输入数值',
            trigger: 'blur'
          },
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ]
      },
      localForm: { compareValue: '' },
      options1: [{
        value: '1',
        label: '设备触发'
      }, {
        value: '2',
        label: '定时触发'
      }],
      options2: [],
      options3: [],
      options4: [{
        value: '1',
        label: '属性触发'
      }, {
        value: '2',
        label: '事件触发'
      }, {
        value: '3',
        label: '上下线触发'
      }], // this.propData.properties
      options5: [],
      options6: [],
      options7: []
    }
  },
  props: {
    itemIndex: {
      type: Number
    },
    title: {
      type: String,
      default: '触发器'
    },
    form: {
      type: Object
    },
    productList: {
      type: Array
    }
  },
  watch: {
    form: {
      handler (value) {
        if (!value.params.productKey) return
        this.localForm.compareValue = value.params.compareValue
        compareValue = value.params.compareType
        deviceList({ productKey: value.params.productKey }).then(res => {
          this.options3 = res.data
        })
        getProductProp({ productKey: value.params.productKey }).then(res => {
          this.propData = res.data.thingModel
          if (value.params.triggerMode === '1') {
            this.options5 = this.propData.properties
            const propertyItem = this.options5.filter(item => {
              return item.identifier === this.form.params.propertyName
            })[0]
            if (propertyItem.dataType.type === 'bool' || propertyItem.dataType.type === 'enum') {
              this.options6 = [{
                value: '=='
              }]
              const specs = propertyItem.dataType.specs
              const keys = Object.keys(specs)
              this.options7 = keys.map(index => {
                return {
                  label: specs[index],
                  value: index
                }
              })
              this.compareType = 0
            } else {
              this.options6 = [{
                value: '>'
              }, {
                value: '>='
              }, {
                value: '<'
              }, {
                value: '<='
              }, {
                value: '=='
              }, {
                value: '!='
              }, {
                value: 'in'
              }, {
                value: 'between'
              }]
              this.compareType = 1
              compareRange = propertyItem.dataType.specs
            }
          } else if (value.params.triggerMode === '2') {
            this.options5 = this.propData.events
          } else {
            this.options5 = [{
              identifier: '1',
              name: '下线'
            }, {
              identifier: '2',
              name: '上线'
            }]
          }
        })
      },
      immediate: true
    },
    productList (value) {
      this.options2 = value
    },
    deviceList (value) {
      this.options3 = value
    }
  },
  mounted () {
  },
  methods: {
    inputChange (value) {
      this.form.params.compareValue = value
    },
    deleteItem () {
      debugger
      const that = this
      this.$confirm('此操作将删除触发器，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.$emit('delete', that.itemIndex)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    triggerModeChange (value) {
      this.$forceUpdate()
      if (value === '2') {
        this.$refs.ruleForm.resetFields()
        this.form.uri = 'trigger/timer'
      }
      this.form.params.productKey = ''
      this.form.params.deviceName = ''
      this.form.params.triggerType = ''
      this.form.params.propertyName = ''
      this.form.params.compareType = ''
      this.form.params.compareValue = ''
      this.localForm.compareValue = ''
    },
    productTypeChange (productKey) {
      this.$refs.ruleForm.resetFields()
      this.form.params.deviceName = ''
      this.form.params.triggerType = ''
      this.form.params.propertyName = ''
      this.form.params.compareType = ''
      this.form.params.compareValue = ''
      this.localForm.compareValue = ''
      deviceList({ productKey }).then(res => {
        this.options3 = res.data
        // this.$forceUpdate()
      })
    },
    deviceChange (deviceName) {
      this.$refs.ruleForm.resetFields()
      this.form.params.triggerType = ''
      this.form.params.propertyName = ''
      this.form.params.compareType = ''
      this.form.params.compareValue = ''
      this.localForm.compareValue = ''
      const item = this.options3.filter(item => {
        return item.deviceName === deviceName
      })[0]
      getProductProp({ productKey: item.productKey }).then(res => {
        this.propData = res.data.thingModel
      })
      this.$forceUpdate()
    },
    // 触发方式改变
    triggerWayChange (value) {
      this.$refs.ruleForm.resetFields()
      this.form.params.propertyName = ''
      this.form.params.compareType = ''
      this.form.params.compareValue = ''
      this.localForm.compareValue = ''
      if (value === '1') {
        this.options5 = this.propData.properties
      } else if (value === '2') {
        this.options5 = this.propData.events
      } else {
        this.options5 = [{
          identifier: '1',
          name: '下线'
        }, {
          identifier: '2',
          name: '上线'
        }]
      }
      switch (value) {
        case '1':
          this.form.uri = 'trigger/device/property'
          break
        case '2':
          this.form.uri = 'trigger/device/event'
          break
        case '3':
          this.form.uri = 'trigger/device/statusChange'
          break
      }
      this.$forceUpdate()
    },
    // 属性改变
    triggerPropChange (identifier) {
      this.$refs.ruleForm.resetFields()
      this.form.params.compareType = ''
      this.form.params.compareValue = ''
      this.localForm.compareValue = ''
      const item = this.options5.filter(item => {
        return item.identifier === identifier
      })[0]
      let dataType = null
      if (item.dataType) {
        dataType = item.dataType
      } else {
        dataType = item.outputData[0].dataType
      }
      if (dataType.type === 'bool' || dataType.type === 'enum') {
        this.options6 = [{
          value: '=='
        }]
        const specs = dataType.specs
        const keys = Object.keys(specs)
        this.options7 = keys.map(index => {
          return {
            label: specs[index],
            value: index
          }
        })
        this.compareType = 0
      } else {
        this.options6 = [{
          value: '>'
        }, {
          value: '>='
        }, {
          value: '<='
        }, {
          value: '!='
        }, {
          value: '=='
        }, {
          value: 'in'
        }, {
          value: 'between'
        }]
        this.compareType = 1
        compareRange = item.dataType.specs
      }
    },
    triggerCompareChange (value) {
      compareValue = value
      this.$refs.ruleForm.resetFields()
      this.localForm.compareValue = ''
      this.form.params.compareValue = ''
      this.$forceUpdate()
    },
    stateChange (value) {
      this.form.params.compareValue = value
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
  .triger-container {
    display: flex;
    flex-direction: row;
    align-items: start;

    .el-button {
      margin: 20px 10px;
    }
  }

  .triger {
    border-radius: 5px;
    width: 75%;
    min-width: 950px;
    margin: 10px 0 5px 0;
    padding: 8px 15px;
    background-color: #efeeee;

    .slects {
      width: 900px;

      .el-form-item {
        margin-bottom: 0px;
      }

      .el-select {
        margin: 5px 0;
        margin-right: 30px;
      }

      .el-input {
        width: 200px;
      }

      .slect-top {
        display: flex;
        flex-direction: row;

        .el-form-item {
          margin-top: 5px;
        }
      }

      .select-bottom {
        display: flex;
        flex-direction: row;

        .el-form-item {
          margin-top: 5px;
        }
      }
    }
  }
</style>
